
function App() {
  return (
    <div style={{ textAlign: "center" }}>
      <img src="/image.png" style={{ margin: "auto" }} />
    </div>
  );
}

export default App;
